export const HANDIN_PROVIDER = 'hand-in';
export const TURNITIN_PROVIDER = 'turnitin';
export const MANUAL = 'manual';

export const gradeTypes = {
  freeform: 'freeform',
  percentage: 'percentage',
  rubric: 'rubric',
  passFail: 'passFail',
};

export const gradeTypeDisplays = {
  freeform: 'Free form',
  percentage: 'Percentages',
  rubric: 'Rubric',
  passFail: 'Pass/Fail',
};
